import React from 'react';
import Icon from '../../../components/AppIcon';

const EscalationRulesTable = ({ rules }) => {
  const triggerTypeLabels = {
    timeout: 'Timeout',
    rejection: 'Rejection',
    threshold_exceeded: 'Threshold Exceeded',
    manual: 'Manual'
  };

  const triggerIcons = {
    timeout: 'Clock',
    rejection: 'XCircle',
    threshold_exceeded: 'AlertTriangle',
    manual: 'User'
  };

  return (
    <div className="space-y-4">
      {rules?.map((rule) => (
        <div key={rule?.id} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-warning/10 flex items-center justify-center">
              <Icon name={triggerIcons?.[rule?.triggerType] || 'AlertCircle'} size={20} className="text-warning" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <h4 className="text-base font-semibold text-foreground">
                  {triggerTypeLabels?.[rule?.triggerType] || rule?.triggerType}
                </h4>
                {rule?.isActive ? (
                  <span className="px-2 py-1 bg-success/10 text-success text-xs rounded">
                    Active
                  </span>
                ) : (
                  <span className="px-2 py-1 bg-muted/10 text-muted-foreground text-xs rounded">
                    Inactive
                  </span>
                )}
              </div>
              <div className="grid grid-cols-2 gap-4 mb-3">
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Escalate To Role</p>
                  <p className="text-sm text-foreground font-medium">{rule?.escalateToRole}</p>
                </div>
                {rule?.escalateToEmail && (
                  <div>
                    <p className="text-xs text-muted-foreground mb-1">Escalate To Email</p>
                    <p className="text-sm text-foreground font-medium">{rule?.escalateToEmail}</p>
                  </div>
                )}
              </div>
              {rule?.notificationMessage && (
                <div className="bg-muted/5 rounded p-3 border-l-4 border-warning">
                  <p className="text-xs text-muted-foreground mb-1">Notification Message</p>
                  <p className="text-sm text-foreground">{rule?.notificationMessage}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      {rules?.length === 0 && (
        <div className="text-center py-8 text-muted-foreground">
          <Icon name="AlertCircle" size={32} className="mx-auto mb-2 opacity-50" />
          <p>No escalation rules configured</p>
        </div>
      )}
    </div>
  );
};

export default EscalationRulesTable;